(() => {
  const ROOT = '[data-lf-cart-feedback]';

  const getCartCount = () => {
    const values = Array.from(document.querySelectorAll('a[href="/cart"], [data-cart-count]'))
      .map((node) => parseInt(String(node.textContent || '').trim(), 10))
      .filter((value) => Number.isFinite(value));
    return values.length ? Math.max.apply(null, values) : 0;
  };

  const humanize = (value) => String(value || '')
    .replace(/_/g, ' · ')
    .replace(/(\d)\s*ml\b/gi, '$1 ml')
    .replace(/\s+/g, ' ')
    .trim();

  const initialize = (toast) => {
    if (!toast || toast.dataset.lfReady === 'true') return;
    const form = toast.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
    toast.dataset.lfReady = 'true';

    const titleNode = toast.querySelector('[data-lf-cart-title]');
    const metaNode = toast.querySelector('[data-lf-cart-meta]');
    const closeButton = toast.querySelector('[data-lf-cart-close]');
    let hideTimer = null;
    let pollTimer = null;

    const hide = () => {
      toast.classList.remove('is-visible');
      window.setTimeout(() => { toast.hidden = true; }, 230);
    };

    const show = (state, title, meta) => {
      window.clearTimeout(hideTimer);
      toast.hidden = false;
      toast.classList.remove('is-loading', 'is-success', 'is-error');
      toast.classList.add('is-' + state);
      if (titleNode) titleNode.textContent = title;
      if (metaNode) metaNode.textContent = meta || '';
      window.requestAnimationFrame(() => toast.classList.add('is-visible'));
    };

    const selectedVariant = () => {
      const select = form.querySelector('select[name="id"]');
      const idInput = form.querySelector('input[name="id"]');
      const id = select ? select.value : idInput ? idInput.value : '';
      let variants = [];
      const jsonNode = form.querySelector('.pr_variants_json');
      try { variants = jsonNode ? JSON.parse(jsonNode.textContent || '[]') : []; } catch (_) {}
      const variant = variants.find((item) => String(item.id) === String(id));
      const selectedLabels = Array.from(form.querySelectorAll('[data-swatch-option]')).map((optionRoot) => {
        const selected = optionRoot.querySelector('[data-swatch-item].is--selected');
        const checked = optionRoot.querySelector('input[type="radio"]:checked');
        return humanize(selected ? selected.getAttribute('data-value') : checked ? checked.value : '');
      }).filter(Boolean);
      return {
        id,
        label: selectedLabels.join(' · ') || humanize(variant && (variant.public_title || variant.title))
      };
    };

    let lastStart = 0;
    const beginFeedback = () => {
      const now = Date.now();
      if (now - lastStart < 250) return;
      lastStart = now;

      const button = form.querySelector('[data-atc-form]');
      if (button && (button.disabled || button.getAttribute('aria-disabled') === 'true')) return;

      const before = getCartCount();
      const variant = selectedVariant();
      const productTitle = toast.dataset.productTitle || 'Product';
      show('loading', 'Adding to cart…', variant.label || productTitle);
      window.clearInterval(pollTimer);

      let attempts = 0;
      pollTimer = window.setInterval(() => {
        attempts += 1;
        const current = getCartCount();
        if (current > before) {
          window.clearInterval(pollTimer);
          show('success', 'Added to cart', variant.label ? productTitle + ' · ' + variant.label : productTitle);
          if (navigator.vibrate) navigator.vibrate(14);
          hideTimer = window.setTimeout(hide, 4200);
        } else if (attempts >= 45) {
          window.clearInterval(pollTimer);
          show('error', 'Cart is taking longer than expected', 'Please retry or open your cart to confirm.');
          hideTimer = window.setTimeout(hide, 5200);
        }
      }, 100);
    };

    form.addEventListener('submit', beginFeedback, true);
    const addButton = form.querySelector('[data-atc-form]');
    if (addButton) {
      addButton.dataset.lfCartFeedbackReady = 'true';
      addButton.addEventListener('click', beginFeedback, true);
    }

    let observedCount = getCartCount();
    const confirmCartChange = () => {
      const current = getCartCount();
      if (current > observedCount) {
        window.clearInterval(pollTimer);
        const variant = selectedVariant();
        const productTitle = toast.dataset.productTitle || 'Product';
        show('success', 'Added to cart', variant.label ? productTitle + ' · ' + variant.label : productTitle);
        if (navigator.vibrate) navigator.vibrate(14);
        window.clearTimeout(hideTimer);
        hideTimer = window.setTimeout(hide, 4200);
      }
      observedCount = current;
    };
    const cartObserver = new MutationObserver(confirmCartChange);
    document.querySelectorAll('a[href="/cart"], [data-cart-count]').forEach((node) => {
      cartObserver.observe(node, { childList: true, subtree: true, characterData: true });
    });

    if (closeButton) closeButton.addEventListener('click', hide);
  };

  const initializeAll = (scope) => (scope || document).querySelectorAll(ROOT).forEach(initialize);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
  } else {
    initializeAll(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();